import React from "react";
import { Route, Routes } from "react-router-dom";
import SpotRegistration from "./SpotRegistration";
import SecurityScan from "./SecurityScan";
import OnsiteReuseContainer from "./OnsiteReuseContainer";
import SelfPrinting from "./SelfPrinting";
import BulkPrinting from "./BulkPrinting";
import SearchPrint from "./SearchPrint";
import ServiceBadge from "./service/ServiceBadge";
import BulkStudent from "./BulkStudent";
import DaywiseFootfall from "./DaywiseFootfall";
import DayWiseFootfallReport from "./DayWiseFootfallReport";
import LocationWiseScanLink from "./LocationWiseScanLink";
import GatwiseScan from "./GatwiseScan";
import OnsiteProtectedRoute from "./OnsiteRouteProtected";
import { ONSITE_MODULE_ITEMS } from "../../utils/constants";
import ServiceBadgeScan from "./ServiceBadgeScan";
import PrintStaffBadges from "../../pages/PrintStaffBadges";
import FootfallComparison from "./FootfallComparison";

const OnsiteContainer = () => {
  return (
    <OnsiteReuseContainer>
      <Routes>
        <Route
          path="spot-registration"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.ONSITE_REGISTRATION}
            >
              <SpotRegistration />
            </OnsiteProtectedRoute>
          }
        />
        <Route
          path="security-scan"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.SECURITY_SCANNING}
            >
              <SecurityScan />
            </OnsiteProtectedRoute>
          }
        />

        <Route
          path="self-printing"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.KIOSK_BADGE_PRINTING}
            >
              <SelfPrinting />
            </OnsiteProtectedRoute>
          }
        />

        <Route
          path="bulk-printing"
          element={
            <OnsiteProtectedRoute module={ONSITE_MODULE_ITEMS.BULK_PRINTING}>
              <BulkPrinting />
            </OnsiteProtectedRoute>
          }
        />

        <Route
          path="search-print"
          element={
            <OnsiteProtectedRoute module={ONSITE_MODULE_ITEMS.SEARCH_AND_PRINT}>
              <SearchPrint />
            </OnsiteProtectedRoute>
          }
        />

        <Route
          path="service-scan"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.SERVICE_BADGE_SCAN}
            >
              <ServiceBadgeScan />
            </OnsiteProtectedRoute>
          }
        />

        <Route
          path="locationwise-scan-link-create"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.LOCATIONWISE_SECURITY_SCAN}
            >
              <LocationWiseScanLink />
            </OnsiteProtectedRoute>
          }
        />

        <Route
          path="gate-scan/:gid"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.LOCATIONWISE_SECURITY_SCAN}
            >
              <GatwiseScan />
            </OnsiteProtectedRoute>
          }
        />

        <Route
          path="bulk-student-badges"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.BULK_STUDENT_BADGES}
            >
              <BulkStudent />
            </OnsiteProtectedRoute>
          }
        />

        <Route
          path="footfall-report"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.FOOTFALL_ANALYSIS}
            >
              <DaywiseFootfall />
            </OnsiteProtectedRoute>
          }
        />

        <Route
          path="daywise-footfall"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.FOOTFALL_ANALYSIS}
            >
              <DayWiseFootfallReport />
            </OnsiteProtectedRoute>
          }
        />
        <Route
          path="footfall-comparison"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.FOOTFALL_ANALYSIS}
            >
              <FootfallComparison />
            </OnsiteProtectedRoute>
          }
        />
        <Route
          path="service-scan"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.SERVICE_BADGE_SCAN}
            >
              <ServiceBadgeScan />
            </OnsiteProtectedRoute>
          }
        />
        <Route
          path="print-staff-badge"
          element={
            <OnsiteProtectedRoute
              module={ONSITE_MODULE_ITEMS.PRINT_STAFF_BADGE}
            >
              <PrintStaffBadges />
            </OnsiteProtectedRoute>
          }
        />
        {/* <Route path="daywise-footfall-report" element={<DaywiseFootfall />} />
         */}
      </Routes>
    </OnsiteReuseContainer>
  );
};

export default OnsiteContainer;
